var _style, _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFighting(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 110 30",
    style: {
      enableBackground: "new 0 0 110 30"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{enable-background:new    ;}\r\n\t.st1{fill:#D94256;}\r\n\t.st2{fill:#FFFFFF;}\r\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    width: 110,
    height: 30
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    transform: "translate(15 15)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Tag_Fight",
    transform: "translate(10 10)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4_1_",
    transform: "translate(5 5)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -15, -15)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-2",
    className: "st1",
    d: "M15,0h80c8.3,0,15,6.7,15,15l0,0c0,8.3-6.7,15-15,15H15C6.7,30,0,23.3,0,15l0,0 C0,6.7,6.7,0,15,0z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Oval_9",
    className: "st2",
    d: "M2,7.7c-3.9,0-7-2.9-7-6.4C-5-0.3-4.3-1.9-3.1-3c0,1.1,0,2.2,0.1,3.3c0,0,0,0,0,0 C-2.6,0.3-2.9-5-2.9-6c0.2-0.9,1.1-1.4,2-1.2c0.4,0.1,0.8,0.4,1,0.7c0,0,0.1,0,0.1,0c0.1,0,0.2,0,0.3,0c0.6-0.7,1.7-0.7,2.3-0.1 C3-6.4,3.2-6.2,3.3-6h0c0.1,0,0.2,0,0.3,0c0.3-0.2,0.6-0.3,0.9-0.3c0.7,0,1.3,0.4,1.6,1.1C6.2-5.1,6.4-5,6.5-5 c0.3-0.2,0.6-0.3,1-0.3C8.3-5.2,9-4.5,9-3.7v5.1c0,1.7-0.8,3.3-2.1,4.5C5.6,7.1,3.8,7.8,2,7.7z"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M48.7,16.2h-3.9v4.1h-2.1v-10h6.5V12h-4.4v2.6h3.9V16.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M52.6,20.3h-2.1v-10h2.1V20.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M62.4,19c-0.4,0.4-0.9,0.8-1.6,1s-1.4,0.4-2.2,0.4c-0.9,0-1.6-0.2-2.3-0.6c-0.6-0.4-1.2-0.9-1.5-1.6 c-0.4-0.7-0.5-1.6-0.5-2.5V15c0-1,0.2-1.9,0.5-2.6s0.8-1.3,1.4-1.7c0.6-0.4,1.4-0.6,2.2-0.6c1.2,0,2.1,0.3,2.8,0.8s1.1,1.4,1.2,2.5 h-2c-0.1-0.6-0.3-1-0.6-1.3c-0.3-0.3-0.7-0.4-1.3-0.4c-0.7,0-1.2,0.3-1.6,0.8S56.3,14,56.3,15v0.6c0,1,0.2,1.8,0.6,2.4 s1,0.8,1.7,0.8c0.8,0,1.3-0.2,1.6-0.5v-1.7h-1.9v-1.5h3.9V19z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M72.1,20.3h-2.1V16h-4v4.3H64v-10h2.1v4h4v-4h2.1V20.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M81.2,12h-3v8.3h-2.1V12h-3v-1.7h8.1V12z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFighting);
export default __webpack_public_path__ + "static/media/fighting.58511553a4d1a7806e735438e1dc0f3c.svg";
export { ForwardRef as ReactComponent };